<template>
  <div class="l-page l-page--message">
    <page-sidebar />
    <main class="l-main">
      <div class="p-breadcrumb">
        <ul class="p-breadcrumb-list">
          <li class="p-breadcrumb-list__item">
            <a href="/coins-admin/reminder/result-list">リマインダープッシュの成果一覧</a>
          </li>
          <li class="p-breadcrumb-list__item">{{ parsedDateListInfo && parsedDateListInfo.reminderId }}</li>
        </ul>
      </div>
      <div class="l-main-head">
        <div class="c-title u-w600">
          <div class="c-title__text c-title__text--blue u-fs34">リマインダープッシュの成果</div>
        </div>
      </div>
      <div class="l-main-content">
        <div class="p-message-result">
          <div v-if="parsedDateListInfo" class="reminder-detail-info">
            <div class="reminder-detail-info__header">
              <div class="reminder-detail-info__meta">
                <div class="reminder-detail-info__id">{{ parsedDateListInfo.reminderId }}</div>
                <span
                  :class="
                    parsedDateListInfo.deliverFlag === 1
                      ? 'deliver-badge deliver-badge--active'
                      : 'deliver-badge deliver-badge--stopped'
                  "
                >{{ deliverStatus }}</span>
              </div>
            </div>
            <div v-if="message" class="reminder-detail-info__grid">
              <div class="mini-preview-card">
                <div class="mini-preview-card__body">
                  <div class="mini-preview-card__content">
                    <div class="mini-preview-card__title">{{ replacePlaceholders(displayTitle) }}</div>
                    <div class="mini-preview-card__text">{{ replacePlaceholders(displayText) }}</div>
                  </div>
                  <div v-if="resolvedIconUrl" class="mini-preview-card__icon">
                    <img :src="resolvedIconUrl" />
                  </div>
                </div>
                <div v-if="displayLargeImageUrl" class="mini-preview-card__image">
                  <img :src="displayLargeImageUrl" />
                </div>
              </div>
              <div class="reminder-detail-info__definitions">
                <div class="reminder-detail-info__label">配信通数</div>
                <div class="reminder-detail-info__value">
                  <strong>{{ scheduleCount }}通</strong>
                </div>

                <template v-if="hasWorkingTime">
                  <div class="reminder-detail-info__label">配信時間帯</div>
                  <div class="reminder-detail-info__value reminder-detail-info__time">
                    <strong>{{ workingStartFormatted }} 〜 {{ workingEndFormatted }}</strong>
                  </div>
                </template>

                <template v-if="hasCondition">
                  <div class="reminder-detail-info__label">配信条件</div>
                  <div class="reminder-detail-info__value">
                    <reminder-condition-summary :condition="message.condition" />
                  </div>
                </template>
              </div>
            </div>
          </div>

          <div class="p-message-search">
            <form action="/" method="get">
              <div class="p-message-search-keyword">
                <button
                  :class="{ 'is-active': isSearchCondition }"
                  class="c-btn c-btn--gray u-w120 u-h32 u-fs--s"
                  type="button"
                  name="open_condition_detail"
                  value="open_condition_detail"
                  @click="onClickSearchCondition"
                >
                  <p class="c-btn__text">絞込み検索</p>
                </button>
              </div>
              <div class="p-message-search-condition" :class="{ 'is-active': isSearchCondition }">
                <div class="c-title u-w1200 p-message-search-with-clear">
                  <div class="c-title__text u-fs22">絞り込み条件の追加</div>
                  <button
                    type="button"
                    name="search_exec"
                    value="search_exec"
                    class="c-btn c-btn--blue u-w200 u-h34 u-fs14"
                    style="margin-left: auto; margin-right: 20px"
                    @click="onSearchClick($event)"
                  >
                    <p class="c-btn__text">検索実行</p>
                  </button>
                  <button
                    type="button"
                    name="clear"
                    value="clear"
                    class="c-btn c-btn--modal c-btn--gray u-w200 u-h34 u-fs14"
                    @click="onClickClearButton"
                  >
                    <p class="c-btn__text">条件クリア</p>
                  </button>
                </div>
                <div
                  class="p-message-search-condition__row p-message-search-condition__row--dates"
                  style="width: 800px; display: flex; align-items: center"
                >
                  <div class="c-input c-input--date-from" style="width: 100px">
                    <label class="c-input__label">期間</label>
                  </div>
                  <div class="c-input" style="flex: 1; display: flex; align-items: center">
                    <div class="c-input-group u-w220" style="display: inline-block">
                      <datepicker
                        ref="refDateFrom"
                        v-model="dateFrom"
                        name="date_from"
                        format="yyyy/MM/dd"
                        placeholder="YYYY/MM/DD"
                        input-class="c-input__item c-input__item--overlay-ico u-w190"
                        calendar-class="datepicker_calendar"
                        :language="ja"
                        :disabled-dates="disabledDates"
                      />
                      <div class="c-input__icon c-input__icon--overlay" @click="showCalendar('date_from')">
                        <div class="c-icon c-icon--white u-wh20">
                          <svg
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                          >
                            <use xlink:href="/assets/img/sprite.svg#calendar" />
                          </svg>
                        </div>
                      </div>
                      <div class="c-error c-error--balloon">
                        <div class="c-error__text"></div>
                      </div>
                    </div>
                    <span style="margin: 0 10px">〜</span>
                    <div class="c-input-group u-w220" style="display: inline-block">
                      <datepicker
                        ref="refDateTo"
                        v-model="dateTo"
                        name="date_to"
                        format="yyyy/MM/dd"
                        placeholder="YYYY/MM/DD"
                        input-class="c-input__item c-input__item--overlay-ico u-w190"
                        calendar-class="datepicker_calendar"
                        :language="ja"
                        :disabled-dates="disabledDates"
                      />
                      <div class="c-input__icon c-input__icon--overlay" @click="showCalendar('date_to')">
                        <div class="c-icon c-icon--white u-wh22">
                          <svg
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                          >
                            <use xlink:href="/assets/img/sprite.svg#calendar" />
                          </svg>
                        </div>
                      </div>
                      <div class="c-error c-error--balloon">
                        <div class="c-error__text"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div v-if="breakdowns" class="p-message-result__data summary-breakdown">
            <div v-if="totals" class="reminder-summary-card">
              <div class="reminder-summary-card__period">
                表示期間：<b>{{ searchPeriodText }}</b>
              </div>
              <div class="reminder-summary-card__metrics">
                <div class="reminder-summary-card__cell">
                  <div class="reminder-summary-card__label-row">
                    <span class="reminder-summary-card__label">インプレッション</span>
                    <span class="reminder-summary-card__icon">
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                        <circle cx="12" cy="12" r="3" />
                      </svg>
                    </span>
                  </div>
                  <div class="reminder-summary-card__value">{{ totals.display_count }}</div>
                </div>
                <div class="reminder-summary-card__cell">
                  <div class="reminder-summary-card__label-row">
                    <span class="reminder-summary-card__label">クリック数</span>
                    <span class="reminder-summary-card__icon">
                      <!--
                                          手アイコン: viewBox は 0 0 24 24 のまま、x 座標のみ中心 (x=12) に向けて
                                          0.8 倍に圧縮することで「横幅だけ細くする」を実現している。
                                          CSS transform: scaleX で縮めると stroke 自体が歪むため (縦線が細くなる)、
                                          ストロークの均一性を保てるよう path の座標値そのものを書き換えている。
                                          arc の rx も同じ係数で縮めて、円→縦長の楕円アークになっている。
                                        -->
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path d="M20 14a6.4 8 0 0 1-6.4 8" />
                        <path d="M16.8 11v-1a1.6 2 0 0 0-3.2 0v1" />
                        <path d="M13.6 10V9a1.6 2 0 1 0-3.2 0v1" />
                        <path d="M10.4 9.5V4a1.6 2 0 1 0-3.2 0v10" />
                        <path
                          d="M16.8 11a1.6 2 0 1 1 3.2 0v3a6.4 8 0 0 1-6.4 8h-1.6c-2.24 0-3.6-.86-4.792-2.34l-2.88-3.6a1.6 2 0 0 1 2.264-2.82L8 15"
                        />
                      </svg>
                    </span>
                  </div>
                  <div class="reminder-summary-card__value">{{ totals.click_count }}</div>
                </div>
                <div class="reminder-summary-card__cell">
                  <div class="reminder-summary-card__label-row">
                    <span class="reminder-summary-card__label">CTR</span>
                    <span class="reminder-summary-card__icon reminder-summary-card__icon--ctr">
                      <!-- 手アイコンは幅圧縮版 path を使用。詳細はクリック数セルのコメント参照 -->
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2.6"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path d="M20 14a6.4 8 0 0 1-6.4 8" />
                        <path d="M16.8 11v-1a1.6 2 0 0 0-3.2 0v1" />
                        <path d="M13.6 10V9a1.6 2 0 1 0-3.2 0v1" />
                        <path d="M10.4 9.5V4a1.6 2 0 1 0-3.2 0v10" />
                        <path
                          d="M16.8 11a1.6 2 0 1 1 3.2 0v3a6.4 8 0 0 1-6.4 8h-1.6c-2.24 0-3.6-.86-4.792-2.34l-2.88-3.6a1.6 2 0 0 1 2.264-2.82L8 15"
                        />
                      </svg>
                      <span class="reminder-summary-card__div">÷</span>
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2.6"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                        <circle cx="12" cy="12" r="3" />
                      </svg>
                    </span>
                  </div>
                  <div class="reminder-summary-card__value">
                    {{ totalsCtrValue }}<span class="reminder-summary-card__unit">%</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="p-message-select-condition-list-type">
              <div class="c-tab">
                <ul class="c-tab-list">
                  <li class="c-tab-list__item" :class="tab == 1 ? 'is-active' : ''" @click="tab = 1">デバイス別集計</li>
                  <li class="c-tab-list__item" :class="tab == 2 ? 'is-active' : ''" @click="tab = 2">OS別集計</li>
                  <li class="c-tab-list__item" :class="tab == 3 ? 'is-active' : ''" @click="tab = 3">ブラウザ別集計</li>
                </ul>
              </div>
            </div>

            <div v-show="tab == 1" class="p-condition-result">
              <div class="p-condition-result__data">
                <reminder-breakdown-chart
                  v-if="breakdowns && breakdowns.devices"
                  :data="breakdowns.devices"
                  name-key="device_name"
                  title="デバイス別集計"
                  :color-map="{ モバイル: '#3cb6d2', PC: '#209bb9', タブレット: '#8ac7d5' }"
                />
                <table class="c-table c-table--condition">
                  <thead>
                    <tr>
                      <th class="c-table__cell--center u-w160"><span class="c-table__text">デバイス別</span></th>
                      <th class="c-table__cell--center u-w290"><span class="c-table__text">インプレッション</span></th>
                      <th class="c-table__cell--center u-w290"><span class="c-table__text">クリック数</span></th>
                      <th class="c-table__cell--center u-w290"><span class="c-table__text">CTR</span></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(device, index) in breakdowns.devices" :key="'d-' + index">
                      <td class="c-table__cell--center c-table__cell--middle">{{ device.device_name }}</td>
                      <td class="c-table__cell--center c-table__cell--middle">{{ device.display_count }}</td>
                      <td class="c-table__cell--center c-table__cell--middle">{{ device.click_count }}</td>
                      <td class="c-table__cell--center c-table__cell--middle">
                        {{ getCtr(device.click_count, device.display_count) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div v-show="tab == 2" class="p-condition-result">
              <div class="p-condition-result__data">
                <reminder-os-breakdown-chart
                  v-if="breakdowns && breakdowns.oses"
                  :data="breakdowns.oses"
                  name-key="os_name"
                  title="OS別集計"
                />
                <table class="c-table c-table--condition">
                  <thead>
                    <tr>
                      <th class="c-table__cell--center u-w160"><span class="c-table__text">OS別</span></th>
                      <th class="c-table__cell--center u-w290"><span class="c-table__text">インプレッション</span></th>
                      <th class="c-table__cell--center u-w290"><span class="c-table__text">クリック数</span></th>
                      <th class="c-table__cell--center u-w290"><span class="c-table__text">CTR</span></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(os, index) in breakdowns.oses" :key="'o-' + index">
                      <td class="c-table__cell--center c-table__cell--middle">{{ os.os_name }}</td>
                      <td class="c-table__cell--center c-table__cell--middle">{{ os.display_count }}</td>
                      <td class="c-table__cell--center c-table__cell--middle">{{ os.click_count }}</td>
                      <td class="c-table__cell--center c-table__cell--middle">
                        {{ getCtr(os.click_count, os.display_count) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div v-show="tab == 3" class="p-condition-result">
              <div class="p-condition-result__data">
                <reminder-breakdown-chart
                  v-if="breakdowns && breakdowns.browsers"
                  :data="breakdowns.browsers"
                  name-key="browser_name"
                  title="ブラウザ別集計"
                  :color-map="{
                    Chrome: '#3cb6d2',
                    Safari: '#6ac9de',
                    Firefox: '#1e7a92',
                    Edge: '#209bb9',
                    その他: '#a3d8e4',
                  }"
                />
                <table class="c-table c-table--condition">
                  <thead>
                    <tr>
                      <th class="c-table__cell--center u-w160"><span class="c-table__text">ブラウザ別</span></th>
                      <th class="c-table__cell--center u-w290"><span class="c-table__text">インプレッション</span></th>
                      <th class="c-table__cell--center u-w290"><span class="c-table__text">クリック数</span></th>
                      <th class="c-table__cell--center u-w290"><span class="c-table__text">CTR</span></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(browser, index) in breakdowns.browsers" :key="'b-' + index">
                      <td class="c-table__cell--center c-table__cell--middle">{{ browser.browser_name }}</td>
                      <td class="c-table__cell--center c-table__cell--middle">{{ browser.display_count }}</td>
                      <td class="c-table__cell--center c-table__cell--middle">{{ browser.click_count }}</td>
                      <td class="c-table__cell--center c-table__cell--middle">
                        {{ getCtr(browser.click_count, browser.display_count) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="c-title u-w1200">
            <div class="c-title__text u-fs22">日別一覧</div>
          </div>
          <reminder-daily-chart
            v-if="!isLoading && summaryServices && summaryServices.data && summaryServices.data.length"
            :data="summaryServices.data"
          />
          <div
            class="p-message-result__data"
            :class="{ 'is-loading': isLoading, 'is-empty': isEmpty, 'is-loaded': !isEmpty && isLoaded }"
          >
            <div class="c-loader c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">リマインダープッシュの成果が存在しません</div>
            </div>
            <table class="c-table cart-result">
              <thead>
                <tr>
                  <th class="c-table__cell--center u-w100 is-sortable">
                    <span class="c-table__text">集計日</span>
                    <sort-switch
                      name="summaryDate"
                      :order="sortTargets.summaryDate"
                      @on-click="onClickSortButton($event)"
                    />
                  </th>
                  <th class="c-table__cell--center u-w134 is-sortable">
                    <span class="c-table__text">インプレッション</span>
                    <sort-switch
                      name="displayCount"
                      :order="sortTargets.displayCount"
                      @on-click="onClickSortButton($event)"
                    />
                  </th>
                  <th class="c-table__cell--center u-w134 is-sortable">
                    <span class="c-table__text">クリック数</span>
                    <sort-switch
                      name="clickCount"
                      :order="sortTargets.clickCount"
                      @on-click="onClickSortButton($event)"
                    />
                  </th>
                  <th class="c-table__cell--center u-w134 is-sortable">
                    <span class="c-table__text">CTR</span>
                    <sort-switch name="ctr" :order="sortTargets.ctr" @on-click="onClickSortButton($event)" />
                  </th>
                </tr>
              </thead>

              <reminder-service-result-list-item
                v-for="(summaryService, index) in summaryServices.data"
                :key="index"
                :summary-service="summaryService"
              />
            </table>
            <pagination :pagination-info="paginationInfo" @on-page-click="onPageClick($event)" />
          </div>
        </div>
      </div>
    </main>

    <error-modal :is-active="isError" :message="errorMessage" :on-close-click="onCloseErrorModal" />
  </div>
</template>

<script>
import Datepicker from '../molecules/Datepicker.vue';
const ja = 'ja';;
import axios from 'axios';

export default {
  components: {
    Datepicker,
  },
  props: {
    csrfToken: String,
    dateListInfo: [Object, String],
  },
  data() {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

    return {
      dateFrom: firstDayOfMonth,
      dateTo: yesterday,
      disabledDates: {
        from: yesterday,
      },
      summaryServices: [],
      totals: null,
      breakdowns: null,
      tab: 1,

      ja: ja,
      sortTargets: {
        summaryDate: -1,
        displayCount: 0,
        clickCount: 0,
        ctr: 0,
      },
      currentSortTarget: null,
      currentSortOrder: null,

      isLoading: false,
      isLoaded: false,
      isEmpty: false,
      isError: false,
      errorMessage: '',
      isSearchCondition: true,

      paginationInfo: null,
      page: 1,
    };
  },
  computed: {
    parsedDateListInfo: function () {
      if (typeof this.dateListInfo === 'string') {
        try {
          return JSON.parse(this.dateListInfo);
        } catch {
          return null;
        }
      }
      return this.dateListInfo;
    },
    totalsCtr: function () {
      if (!this.totals || !this.totals.display_count || !this.totals.click_count) return '0.00%';
      var ctr = (this.totals.click_count * 100) / this.totals.display_count;
      return ctr.toFixed(2) + '%';
    },
    // CTR の数値部のみ(単位 % を別要素で表示するため分離)
    totalsCtrValue: function () {
      if (!this.totals || !this.totals.display_count || !this.totals.click_count) return '0.00';
      var ctr = (this.totals.click_count * 100) / this.totals.display_count;
      return ctr.toFixed(2);
    },
    searchPeriodText: function () {
      var fmt = function (d) {
        if (!d) return '';
        var dt = d instanceof Date ? d : new Date(d);
        if (isNaN(dt.getTime())) return '';
        return (
          dt.getFullYear() +
          '/' +
          String(dt.getMonth() + 1).padStart(2, '0') +
          '/' +
          String(dt.getDate()).padStart(2, '0')
        );
      };
      return fmt(this.dateFrom) + ' 〜 ' + fmt(this.dateTo);
    },
    message: function () {
      return (this.parsedDateListInfo && this.parsedDateListInfo.message) || null;
    },
    firstSchedule: function () {
      if (!this.message || !this.message.schedules || this.message.schedules.length === 0) return null;
      return (
        this.message.schedules.find(function (s) {
          return s.schedule_index === 0;
        }) || this.message.schedules[0]
      );
    },
    displayTitle: function () {
      if (this.message && this.message.message_title) return this.message.message_title;
      if (this.firstSchedule) return this.firstSchedule.message_title;
      return '';
    },
    displayText: function () {
      if (this.message && this.message.message_text) return this.message.message_text;
      if (this.firstSchedule) return this.firstSchedule.message_text;
      return '';
    },
    displayLargeImageUrl: function () {
      if (this.firstSchedule && this.firstSchedule.large_image_url) return this.firstSchedule.large_image_url;
      return null;
    },
    resolvedIconUrl: function () {
      if (this.firstSchedule && this.firstSchedule.icon_url) return this.firstSchedule.icon_url;
      return (this.parsedDateListInfo && this.parsedDateListInfo.defaultIconUrl) || null;
    },
    deliverStatus: function () {
      return this.parsedDateListInfo && this.parsedDateListInfo.deliverFlag === 1 ? '配信中' : '停止中';
    },
    scheduleCount: function () {
      if (this.message && this.message.schedules && this.message.schedules.length > 0) {
        return this.message.schedules.length;
      }
      return 1;
    },
    hasWorkingTime: function () {
      return this.message && this.message.working_start_time != null && this.message.working_end_time != null;
    },
    workingStartFormatted: function () {
      if (!this.hasWorkingTime) return '';
      var v = Number(this.message.working_start_time);
      return String(Math.floor(v / 100)).padStart(2, '0') + ':' + String(v % 100).padStart(2, '0');
    },
    workingEndFormatted: function () {
      if (!this.hasWorkingTime) return '';
      var v = Number(this.message.working_end_time);
      return String(Math.floor(v / 100)).padStart(2, '0') + ':' + String(v % 100).padStart(2, '0');
    },
    hasCondition: function () {
      if (!this.message || !this.message.condition) return false;
      var c = this.message.condition;
      // ReminderConditionSummary は set/unset/exclude の 3 セクションを描画するため、
      // 判定側も 3 種全ての UrlNode 有無を見る必要がある (exclude だけ設定されたケースの取りこぼし防止)。
      return (
        this._hasUrlNodes(c.condition_set) ||
        this._hasUrlNodes(c.condition_unset) ||
        this._hasUrlNodes(c.condition_exclude)
      );
    },
  },
  mounted: function () {
    import('../../funcs/pages/message').then((module) => {
      module.Message();
      this.loadData();
    });
  },
  methods: {
    loadData: function () {
      let sortTarget = null;
      let order = null;
      for (let workTarget in this.sortTargets) {
        if (this.sortTargets[workTarget] != 0) {
          sortTarget = workTarget;
          order = this.sortTargets[workTarget];
          break;
        }
      }

      let from;
      let to;

      from = this.dateFrom ? this.getDateStringFromDateObject(this.dateFrom) : '';
      to = this.dateTo ? this.getDateStringFromDateObject(this.dateTo) : '';

      const params = {
        params: {
          sort: sortTarget,
          order: order,
          page: this.page,
          message_id: this.parsedDateListInfo ? this.parsedDateListInfo.messageId : null,
        },
      };

      if (from && from !== '') {
        params.params.from = from;
      }
      if (to && to !== '') {
        params.params.to = to;
      }

      this.isLoading = true;
      this.isLoaded = false;

      axios
        .get('/api/reminder/summary/service', params)
        .then((res) => {
          this.summaryServices = res.data.items;
          this.paginationInfo = res.data.items;
          if (res.data.totals) {
            this.totals = res.data.totals;
          }
          if (res.data.breakdowns) {
            this.breakdowns = res.data.breakdowns;
          }
          setTimeout(() => {
            this.isLoading = false;
            this.isLoaded = true;
            if (res.data.items.data.length < 1) {
              this.isEmpty = true;
            } else {
              this.isEmpty = false;
            }
          }, 300);
        })
        .catch((error) => {
          this.handleHttpError(error);
          setTimeout(() => {
            this.isError = true;
            this.errorMessage = 'リマインダー成果一覧の取得時にエラーが発生しました';
            this.isLoading = false;
          }, 300);
        });
    },

    onClickSearchCondition: function () {
      this.isSearchCondition = !this.isSearchCondition;
    },

    onClickSortButton: function (target) {
      this.currentSortTarget = target;
      if (!this.sortTargets[target] || this.sortTargets[target] == -1) {
        this.sortTargets[target] = 1;
      } else {
        this.sortTargets[target] = -1;
      }

      for (let workTarget in this.sortTargets) {
        if (workTarget != target) {
          this.sortTargets[workTarget] = 0;
        }
      }
      this.loadData();
    },

    replacePlaceholders: function (text) {
      if (!text || !this.message) return text;
      var placeholders = this.message.placeholders || [];
      placeholders.forEach(function (ph) {
        if (ph.placeholder_key) {
          var replacement = ph.default_value || '{{' + ph.placeholder_key + '}}';
          text = text.split('{{' + ph.placeholder_key + '}}').join(replacement);
          text = text.split('{' + ph.placeholder_key + '}').join(replacement);
        }
      });
      return text;
    },

    // v1 RuleRoot に 1 件以上の UrlNode が含まれるか判定(ネスト混入も防御的に展開)
    _hasUrlNodes: function (ruleRoot) {
      if (!ruleRoot || !ruleRoot.conditions || !ruleRoot.conditions.pages) return false;
      var stack = (ruleRoot.conditions.pages.children || []).slice();
      while (stack.length > 0) {
        var n = stack.shift();
        if (!n) continue;
        if (n.type === 'url') return true;
        if (n.type === 'group') stack = (n.children || []).concat(stack);
      }
      return false;
    },

    getCtr: function (clickCount, displayCount) {
      if (displayCount > 0 && clickCount > 0) {
        var ctr = (clickCount * 100) / displayCount;
        return ctr.toFixed(2) + '%';
      }
      return '0.00%';
    },

    onCloseErrorModal: function () {
      this.isError = false;
      this.errorMessage = '';
    },

    showCalendar: function (name) {
      const list = {
        date_from: 'refDateFrom',
        date_to: 'refDateTo',
      };

      Object.keys(list).forEach((key, _index) => {
        if (!this.$refs[list[key]]) return;
        if (name == key) {
          this.$refs[list[key]].$el.querySelector('input').focus();
          this.$refs[list[key]].showCalendar();
        } else {
          this.$refs[list[key]].close(true);
        }
      });
    },

    onSearchClick: function (event) {
      event.preventDefault();
      this.page = 1;
      this.loadData();
    },

    onClickClearButton: function () {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);
      const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      this.dateFrom = firstDayOfMonth;
      this.dateTo = yesterday;
      this.page = 1;
      this.loadData();
    },

    onPageClick: function (clickPage) {
      this.page = clickPage;
      this.loadData();
    },
  },
};
</script>

<style scoped>
/* タブ上に表示する検索期間サマリーカード（期間・IMP・CLK・CTRを横並び表示） */
.reminder-summary-card {
  padding: 0;
  margin-top: 20px;
  margin-bottom: 18px;
}

.reminder-summary-card__period {
  font-size: 17px;
  color: #64748b;
  padding-bottom: 12px;
}

.reminder-summary-card__period b {
  color: #364d5f;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

/* 青バーに3セル分割でメトリクスを表示するメイン表示ブロック */
.reminder-summary-card__metrics {
  background: #209bb9;
  border-radius: 10px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  padding: 8px;
}

.reminder-summary-card__cell {
  padding: 22px 28px 24px;
  color: #fff;
}

.reminder-summary-card__cell + .reminder-summary-card__cell {
  border-left: 1px solid rgba(255, 255, 255, 0.22);
}

.reminder-summary-card__label-row {
  display: flex;
  align-items: center;
  gap: 10px;
  color: rgba(255, 255, 255, 0.92);
  margin-bottom: 10px;
}

.reminder-summary-card__label {
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.06em;
  /* Pattern D 参照デザインの高さ(138.49px)に合わせるため line-height を 1.6 固定。
       スコープド CSS で小さな line-height が継承されると label-row が 20px(アイコン依存)になり
       全体で約2.4px縮むのを防ぐ。 */
  line-height: 1.6;
}

.reminder-summary-card__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.reminder-summary-card__icon svg {
  width: 20px;
  height: 20px;
  display: block;
}

/* CTR は「クリック÷インプレッション」を1セットのアイコンで示す */
.reminder-summary-card__icon--ctr {
  gap: 1px;
}

.reminder-summary-card__icon--ctr svg {
  width: 12px;
  height: 12px;
}

.reminder-summary-card__div {
  font-size: 13px;
  font-weight: 900;
  line-height: 1;
  letter-spacing: -0.04em;
  padding: 0 3px 3px 1px;
  color: #fff;
}

.reminder-summary-card__value {
  color: #fff;
  font-size: 42px;
  font-weight: 700;
  line-height: 1.05;
  letter-spacing: -0.01em;
  font-variant-numeric: tabular-nums;
  font-feature-settings: 'tnum';
}

.reminder-summary-card__unit {
  color: #fff;
  font-size: 24px;
  font-weight: 700;
  margin-left: 3px;
  opacity: 0.95;
}

/* 集計タブ: 非アクティブは灰色枠＋グレー文字、アクティブは下のみシアンの太線 */
.p-message-select-condition-list-type {
  margin-top: 50px;
}

.p-message-select-condition-list-type .c-tab-list {
  justify-content: flex-start;
}

.p-message-select-condition-list-type .c-tab-list__item {
  flex: 1;
  height: auto;
  padding: 12px 0;
  font-size: 16px;
  font-weight: 600;
  color: #64748b;
  background: #ffffff;
  border: 1px solid #cccccc;
  border-radius: 8px 8px 0 0;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
  cursor: pointer;
  /* 隣接タブのボーダーを重ねて詰める */
  margin-right: -1px;
}

/* タブ直下のコンテンツ領域はタブボーダーと繋げるため上線を消す */
.summary-breakdown .p-condition-result {
  border-top: 0;
}

.p-message-select-condition-list-type .c-tab-list__item:last-child {
  margin-right: 0;
}

.p-message-select-condition-list-type .c-tab-list__item:hover {
  background: #f7fcfd;
  color: #0097a7;
}

.p-message-select-condition-list-type .c-tab-list__item.is-active {
  color: #0097a7;
  background: #ffffff;
  border-bottom: 4px solid #00bcd4;
  /* 下ボーダー増加分を相殺して高さを揃える */
  padding-bottom: 9px;
  position: relative;
  z-index: 1;
  cursor: pointer;
}

.reminder-detail-info {
  background: #f8f8f8;
  padding: 16px 20px;
  margin-bottom: 20px;
}

.reminder-detail-info__header {
  margin-bottom: 12px;
}

.reminder-detail-info__meta {
  display: flex;
  align-items: center;
  gap: 12px;
}

.reminder-detail-info__id {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.deliver-badge {
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  padding: 2px 12px;
  border-radius: 10px;
}

.deliver-badge--active {
  background: #d8f0f6;
  color: #209bb9;
}

.deliver-badge--stopped {
  background: #e8e8e8;
  color: #888;
}

/* 左にプレビューカード、右に定義リスト(配信通数/時間帯/条件)を配置する2カラムレイアウト */
.reminder-detail-info__grid {
  display: grid;
  grid-template-columns: minmax(0, 420px) 1fr;
  gap: 24px;
  align-items: start;
}

/* ラベル列(固定幅) + 値列(可変)の定義リスト構造 */
.reminder-detail-info__definitions {
  display: grid;
  grid-template-columns: 80px 1fr;
  row-gap: 10px;
  column-gap: 16px;
  font-size: 12px;
}

.reminder-detail-info__label {
  color: #999;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.3px;
}

.reminder-detail-info__value {
  color: #333;
}

.reminder-detail-info__time {
  font-variant-numeric: tabular-nums;
}

.reminder-detail-info__conditions {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.reminder-detail-info__cond-row {
  line-height: 1.5;
  word-break: break-all;
}

.mini-preview-card {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
}

.mini-preview-card__body {
  display: flex;
  padding: 10px 12px;
  gap: 10px;
}

.mini-preview-card__content {
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.mini-preview-card__title {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 4px;
}

.mini-preview-card__text {
  font-size: 12px;
  color: #666;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.4;
}

.mini-preview-card__icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 4px;
  overflow: hidden;
  background: #eee;
}

.mini-preview-card__icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.mini-preview-card__image {
  width: 100%;
  overflow: hidden;
}

.mini-preview-card__image img {
  width: 100%;
  display: block;
}

.summary-breakdown {
  margin-bottom: 50px;
}
</style>

<style>
/* デフォルトの .c-table tbody.is-editable tr { height: 60px } を打ち消し、
   td の padding (15px) で決まる自然高 (約49.75px) に揃える */
.p-message-result__data .c-table.cart-result tbody.is-editable tr {
  height: auto;
}

/* is-sortable により padding:0 !important が効くため height で高さを揃える。
   ブレイクダウン表の thead tr と一致させるため 37px に変更 */
.p-message-result__data .c-table.cart-result thead tr th {
  height: 37px;
}
</style>
